// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__0peLX","rotate":"Loading_rotate__ZztiU","ball1":"Loading_ball1__vyQFE","ball2":"Loading_ball2__NRDkv"};